const URL = process.env.NODE_ENV === 'production' ? 'http://jycyhb.cn/' : 'https://localhost:44311/';
export default URL;